module.exports = __webpack_public_path__ + "img/cat.c00ae8f7.svg";